export default {
    READ_CALL_RECORDINGS_SETTINGS_OPTIONS_REQUEST: 'READ_CALL_RECORDINGS_SETTINGS_OPTIONS_REQUEST',
    READ_CALL_RECORDINGS_SETTINGS_OPTIONS_SUCCESS: 'READ_CALL_RECORDINGS_SETTINGS_OPTIONS_SUCCESS',
    READ_CALL_RECORDINGS_SETTINGS_OPTIONS_FAILURE: 'READ_CALL_RECORDINGS_SETTINGS_OPTIONS_FAILURE',

    UPDATE_CALL_RECORDINGS_SETTINGS_OPTIONS_REQUEST: 'UPDATE_CALL_RECORDINGS_SETTINGS_OPTIONS_REQUEST',
    UPDATE_CALL_RECORDINGS_SETTINGS_OPTIONS_SUCCESS: 'UPDATE_CALL_RECORDINGS_SETTINGS_OPTIONS_SUCCESS',
    UPDATE_CALL_RECORDINGS_SETTINGS_OPTIONS_FAILURE: 'UPDATE_CALL_RECORDINGS_SETTINGS_OPTIONS_FAILURE'
}
